/*
Componente para scanear codigos de barras
*/

import React, { useState, useEffect } from 'react'
import Quagga from 'quagga'

// #region CSS
// import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
// import Button from '@material-ui/core/Button'
// import FlipCameraIosIcon from '@material-ui/icons/FlipCameraIos'

/* const useStyles = makeStyles(theme => ({
  btn_camera: {
    color: 'white'
  }
})) */
// #endregion

// powerOff = setPowerOn(false);
let canCheckCode = true
export default function ScanCode({ powerOn, powerOff, setCode, options }) {
  // const classes = useStyles()
  const [turnOn, setTurnOn] = useState(powerOn)
  const [swapCamera, setSwapCamera] = useState(true)// false=camara delantera true = camara trasera
  let localstream

  const media = mode => navigator.getUserMedia({
    video: {
      facingMode: mode
    }
  },
  function (stream) {
    const video = document.getElementById('video-player')
    localstream = stream
    if (localstream && video) {
      video.srcObject = localstream

      Quagga.init({
        inputStream: {
          name: 'Live',
          type: 'LiveStream',
          target: video
        },
        // frequency: 1,
        decoder: {
          readers: ['code_128_reader', 'ean_reader'] //, "ean_8_reader"
        }
      }, function (err) {
        if (err) {
          // console.log(err)
          return
        }
        Quagga.start()
      })

      Quagga.onDetected(function (result) {
        if (powerOn) {
          if (canCheckCode) {
            canCheckCode = false
            var code = result.codeResult.code
            setCode(code)
          }
        }
      })
    }
  },
  function (e) {
    const video = document.getElementById('video-player')
    if (video) {
      video.srcObject = null
    }
  })

  useEffect(() => {
    if (turnOn) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        media(swapCamera ? { exact: 'environment' } : 'user')
      } else {
        alert('Navigator.mediaDevices not supported')
      }
    }
    setTurnOn(powerOn)
    return () => {
      if (localstream) {
        localstream.getAudioTracks().forEach(function (track) {
          track.stop()
        })
        localstream.getVideoTracks().forEach(function (track) {
          track.stop()
        })
        Quagga.offProcessed()
        Quagga.offDetected()
        Quagga.stop()
        const video = document.getElementById('video-player')
        if (video !== null) {
          video.pause()
          video.currentTime = 0
        }
      }
      // localstream = null;
    }
    // eslint-disable-next-line
    }, [turnOn, powerOn, swapCamera]);

  useEffect(() => {
    if (!options.isLoading) { canCheckCode = true }
    // eslint-disable-next-line
    }, [options.isLoading]);

  return (
    <Grid container
      direction='row'
      justify='center'
      alignItems='center'>
      <Grid item >
        {/* <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.btn_camera}
                    onClick={() => setSwapCamera(!swapCamera)}
                    startIcon={<FlipCameraIosIcon style={{ marginLeft: "15px" }} />}
                /> */}
        <div data-lang="gift_scan_tap_to_close" style={{ color: 'white', position: 'absolute' }}>Tocar para cerrar</div>
        <video id='video-player' autoPlay={true} style={{ objectFit: 'cover', width: options.width ? options.width : '100%', height: options.width ? '185px' : '100%' }} onClick={() => powerOff()} />
      </Grid>
    </Grid>
  )
}
